import manifest from '../sprites/manifest.json'

// The drone at rest: every corridor drone tile plays the `drone-hover` loop
// (a wasp, head up) when its PNG is in src/gate1/sprites/, else keeps its
// placeholder tile. It runs all the time, so it also covers the drones
// before the launch in the reveal beat. The art faces up, toward the enemy
// for the bottom (own) side; top-side drones are turned 180° to face down.
// Each drone starts at its own frame so the Hive doesn't flap in step.
// step() allocates nothing (it runs on every frame, like a beat's step()).

const KEY = 'drone-hover'

export function createDroneHover(root, textures) {
    const frames = textures.frames?.(KEY) ?? null
    const drones = []
    const walk = n => { if (n.gate1?.key.startsWith('drone:')) drones.push(n); for (const ch of n.children ?? []) walk(ch) }
    walk(root)
    if (!frames || !drones.length) return { drones: 0, frames: 0, step() {} }

    const n = frames.length
    const fps = manifest.sprites[KEY].fps ?? 24
    // Drawn this much larger than the drone tile (display only: the texture
    // stays 256 px, so the load is unchanged).
    const scale = manifest.sprites[KEY].scale ?? 1
    const offset = drones.map((_, i) => (i * 7) % n)
    for (const sp of drones) {
        const { w, h } = frames[0].gate1Size
        sp.texture = frames[0]
        sp.width = w * scale
        sp.height = h * scale
        if (sp.gate1.key.startsWith('drone:opp:')) sp.rotation = Math.PI
    }
    let last = -1
    return {
        drones: drones.length,
        frames: n,
        fps,
        step(now) {
            const f = Math.floor((now * fps) / 1000) % n
            if (f === last) return
            last = f
            for (let i = 0; i < drones.length; i++) drones[i].texture = frames[(f + offset[i]) % n]
        },
    }
}
